import { useLang } from '@/i18n';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';
import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Tab4 from './Tab4';

const E: React.FC = () => {
    const { t } = useLang('stream.overview');
    const [activeTab, setActiveTab] = useState(0);
    const [initedTabs, setInitedTabs] = useState([true, false, false]);
    const tabs: string[] = [t('E_tab1'), t('E_tab3'), t('E_tab4')];

    const handleChangeTab = (e: any, idx: number) => {
        setActiveTab(idx);
        if (idx !== -1 && !initedTabs?.[idx]) {
            const newInited = JSON.parse(JSON.stringify(initedTabs));
            newInited[idx] = true;
            setInitedTabs(newInited);
        }
        if (window.innerWidth < 1024) {
            e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    };

    const indicatorRef = useRef<HTMLDivElement>(null);
    const tabsRef = useRef<HTMLUListElement>(null);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!indicatorRef.current || !tabsRef.current) return;

        const activeEl = tabsRef.current.querySelector('.active') as HTMLDivElement;
        if (!activeEl) return;
        const { left: tabsLeft } = tabsRef.current.getBoundingClientRect();
        const { width, left } = activeEl.getBoundingClientRect();

        indicatorRef.current.style.transform = `translateX(${left - tabsLeft + tabsRef.current.scrollLeft}px)`;
        indicatorRef.current.style.width = `${width}px`;
    }, [activeTab]);

    useOnceInView('.stream-nl-E .title', () => {
        document.querySelector('.stream-nl-E .title')?.classList.add('enter');
        document.querySelector('.stream-nl-E .desc')?.classList.add('enter');
        document.querySelector('.stream-nl-E .content')?.classList.add('enter');
    });

    return (
        <div className={`${css.section} stream-nl-E GtmModuleData-section space`} id="stream-nl-E" data-section-id={'stream-nl-E'}>
            <div className="info">
                <h2 className="title ani-1">{t('E_title')}</h2>
                <p className="desc ani-2">{t('E_desc')}</p>
            </div>
            <div className="content ani-3">
                <div className="box">
                    {initedTabs?.[0] && (
                        <div className={`box-tab${activeTab === 0 ? ' active' : ''}`}>
                            <Tab1 />
                        </div>
                    )}
                    {/* {initedTabs?.[1] && (
                        <div className={`box-tab${activeTab === 1 ? ' active' : ''}`}>
                            <Tab2 />
                        </div>
                    )} */}
                    {initedTabs?.[1] && (
                        <div className={`box-tab${activeTab === 1 ? ' active' : ''}`}>
                            <Tab3 />
                        </div>
                    )}
                    {initedTabs?.[2] && (
                        <div className={`box-tab${activeTab === 2 ? ' active' : ''}`}>
                            <Tab4 />
                        </div>
                    )}
                </div>
                <ul className="tabs" ref={tabsRef}>
                    {tabs?.map((tab: string, i: number) => (
                        <li className={`tab tab-${i + 1}${activeTab === i ? ' active' : ''}`} key={tab} onClick={(e: any) => handleChangeTab(e, i)}>
                            {tab}
                        </li>
                    ))}
                    <div className="tab-indicator" ref={indicatorRef}></div>
                </ul>
            </div>
        </div>
    );
};

export default E;
